export const getCurrentPSTDate = (inputDate:Date = new Date()) => {
    let pstDate : Date = new Date(inputDate.toLocaleString("en-US", {timeZone: "America/Los_Angeles"}))
    return pstDate
}

export const getLastClosedMonDts = (startMonth: any) => {
    const lastClosedMonDt: Date = new Date(
        parseInt(startMonth.substring(0, 4)),
        parseInt(startMonth.substring(5, 7)),
        0
    );
    const lastClosedMonDtStr = getDateStr(lastClosedMonDt);
    return { lastClosedMonDt, lastClosedMonDtStr };
};

const getDateStr = (ipDate: Date) => {
    return (
        ipDate.getFullYear() +
        '-' +
        (ipDate.getMonth() + 1) +
        '-' +
        ipDate.getDate()
    );
};

export function formatTimestamp(timestamp: string): string {
    const date = new Date(timestamp)

    const month = (date.getMonth()+1).toString()
    const day = date.getDate().toString()
    const year = date.getFullYear().toString()

    return `${month}/${day}/${year}`;
}